/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useTheme, Box, useMediaQuery, Grid, Typography, TextField, Button, MenuItem, Alert } from '@mui/material';
import { backendApi } from '../../../components/Api';
const serverUrl = process.env.REACT_APP_SERVER_URL

const validationSchema = yup.object({
  name: yup
    .string()
    .min(2, 'Please enter a valid your name')
    .max(50, 'Please enter a valid your name')
    .required('Please specify your name'),
  company_name: yup
    .string()
    .min(2, 'Please enter a valid company name')
    .max(50, 'Please enter a valid company name')
    .required('Please specify company name'),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  phone_number: yup
    .string()
    .min(10, 'Please enter a valid phone number')
    .required('Please specify phone number'),
  country: yup
    .string()
    .required('Please specify country'),
  topic: yup
    .string()
    .required('Please select an issue'),
  issue: yup
    .string()
    .required('Please describe your issue'),
});

const countryList = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre and Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts and Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];
const issueList = ["I have a question about the report", "I am having issues with the tool/report generated", "I am interested in services to improve my analytics setup", "I have another request"];
const Form = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const [alertMessage, setAlertMessage] = useState('');

  let userDetails = localStorage.getItem("userDetails");
  userDetails = JSON.parse(userDetails)
  let fullName = ''
  if (userDetails?.firstname && userDetails?.lastname) {
    fullName = `${userDetails.firstname} ${userDetails.lastname}`
  }

  let initialValues = {
    name: fullName ? fullName : '',
    company_name: '',
    email: userDetails?.email ? userDetails.email : '',
    phone_number: '',
    country: '',
    topic: '',
    issue: '',
  };

  const onSubmit = async (values, actions) => {
    let token = localStorage.getItem('access_token');
    let body = values;
    let getData = await backendApi(`${serverUrl}api/user/contact`, body, token)

    setAlertMessage(getData?.message)
    actions.resetForm({
      name: fullName ? fullName : '',
      company_name: '',
      email: userDetails?.email ? userDetails.email : '',
      phone_number: '',
      country: '',
      topic: '',
      issue: '',
    })
    setTimeout(() => {
      setAlertMessage('')
    }, 5000);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit,
  });

  return (
    <Box className="contact-formbox">
      <Box paddingBottom={4} margin={'0 auto'}
        component={'form'}
        onSubmit={formik.handleSubmit}
        sx={{
          '& .MuiOutlinedInput-root.MuiInputBase-multiline': {
            padding: 0,
          },
          '& .MuiOutlinedInput-input': {
            background: theme.palette.background.paper,
            padding: 2,
          },
        }}
      >
        <Grid container spacing={isMd ? 4 : 2}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={700}
              gutterBottom
            >
              Your name*
            </Typography>
            <TextField
              placeholder="Your name"
              variant="outlined"
              size="medium"
              name="name"
              fullWidth
              type="text"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={700}
              gutterBottom
            >
              Company Name*
            </Typography>
            <TextField
              placeholder="Company name"
              variant="outlined"
              size="medium"
              name="company_name"
              fullWidth
              type="text"
              value={formik.values.company_name}
              onChange={formik.handleChange}
              error={formik.touched.company_name && Boolean(formik.errors.company_name)}
              helperText={formik.touched.company_name && formik.errors.company_name}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={700}
              gutterBottom
            >
              Email*
            </Typography>
            <TextField
              placeholder="Your e-mail address"
              variant="outlined"
              size="medium"
              name="email"
              fullWidth
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={700}
              gutterBottom
            >
              Phone Number*
            </Typography>
            <TextField
              placeholder="Phone number"
              variant="outlined"
              size="medium"
              name="phone_number"
              fullWidth
              type="text"
              value={formik.values.phone_number}
              onChange={formik.handleChange}
              error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
              helperText={formik.touched.phone_number && formik.errors.phone_number}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={700}
              gutterBottom
            >
              Country*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="country"
              id="outlined-select-country-native"
              select
              SelectProps={{
                native: true
              }}
              // label="Select country"
              value={formik.values.country}
              onChange={formik.handleChange}
              error={
                formik.touched.country &&
                Boolean(formik.errors.country)
              }
              helperText={
                formik.touched.country && formik.errors.country
              }
            >
              <option value={""}>
                {"-Select a Country-"}
              </option>
              {countryList.map((option, i) => (
                <option key={`Country-${option}-${i}`} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={700}
              gutterBottom
            >
              Select a topic you need to help with*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="topic"
              id="outlined-select-topic-native"
              select
              SelectProps={{
                native: true
              }}
              // label="Select topic"
              value={formik.values.topic}
              onChange={formik.handleChange}
              error={
                formik.touched.topic &&
                Boolean(formik.errors.topic)
              }
              helperText={
                formik.touched.topic && formik.errors.topic
              }
            >
              <option value={""}>
                {"-Select a Topic-"}
              </option>
              {issueList.map((option) => (
                <option key={`Topic${option}`} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              fontWeight={700}
              gutterBottom
            >
              Describe your issue*
            </Typography>
            <TextField
              placeholder="Your question about our services"
              variant="outlined"
              name="issue"
              fullWidth
              multiline
              rows={4}
              value={formik.values.issue}
              onChange={formik.handleChange}
              error={formik.touched.issue && Boolean(formik.errors.issue)}
              helperText={formik.touched.issue && formik.errors.issue}
            />
          </Grid>
          <Grid item container justifyContent="center" xs={12}>
            <Button className='theme-btn'
              type="submit"
              color="primary"
              size="large"
              fullWidth
            >
              Submit
            </Button>
            {alertMessage ?
              <Alert severity="success">{alertMessage}</Alert>
              : ''}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Form;
